import React from 'react';
import { Link } from 'react-router-dom';

const CLFExamPage: React.FC = () => {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--gray-100)' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '24px' }}>
        {/* Header */}
        <div style={{ marginBottom: '32px' }}>
          <Link to="/" style={{ color: 'var(--blue)', marginBottom: '16px', display: 'inline-block' }}>
            ← Back to Home
          </Link>
          <h1 style={{ fontSize: '2rem', fontWeight: 800, color: 'var(--gray-800)', marginBottom: '8px' }}>
            AWS Certified Cloud Practitioner (CLF-C02)
          </h1>
          <p style={{ color: 'var(--gray-500)', fontSize: '1.1rem' }}>
            Complete study guide and exam preparation
          </p>
        </div>

        {/* Exam Info Card */}
        <div style={{ 
          background: '#fff', 
          borderRadius: '12px', 
          boxShadow: 'var(--shadow-sm)', 
          padding: '24px', 
          marginBottom: '24px' 
        }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '16px', color: 'var(--gray-800)' }}>
            Exam Overview
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
            <div>
              <span style={{ color: 'var(--gray-500)', fontSize: '0.875rem' }}>Exam Code</span>
              <p style={{ fontWeight: 600, color: 'var(--gray-800)' }}>CLF-C02</p>
            </div>
            <div>
              <span style={{ color: 'var(--gray-500)', fontSize: '0.875rem' }}>Duration</span>
              <p style={{ fontWeight: 600, color: 'var(--gray-800)' }}>90 minutes</p>
            </div>
            <div>
              <span style={{ color: 'var(--gray-500)', fontSize: '0.875rem' }}>Questions</span>
              <p style={{ fontWeight: 600, color: 'var(--gray-800)' }}>65 questions</p>
            </div>
            <div>
              <span style={{ color: 'var(--gray-500)', fontSize: '0.875rem' }}>Passing Score</span>
              <p style={{ fontWeight: 600, color: 'var(--gray-800)' }}>700/1000</p>
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div style={{ display: 'grid', gap: '24px' }}>
          {/* Study Guide Section */}
          <div style={{ 
            background: '#fff', 
            borderRadius: '12px', 
            boxShadow: 'var(--shadow-sm)', 
            padding: '24px' 
          }}>
            <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '16px', color: 'var(--gray-800)' }}>
              📚 Study Guide
            </h2>
            <p style={{ color: 'var(--gray-600)', marginBottom: '16px', lineHeight: 1.7 }}>
              The AWS Certified Cloud Practitioner (CLF-C02) exam validates your ability to:
            </p>
            <ul style={{ paddingLeft: '20px', color: 'var(--gray-600)' }}>
              <li style={{ marginBottom: '8px' }}>Explain the value of the AWS Cloud</li>
              <li style={{ marginBottom: '8px' }}>Understand security and compliance in the AWS Cloud</li>
              <li style={{ marginBottom: '8px' }}>Understand AWS Cloud architecture and core services</li>
              <li style={{ marginBottom: '8px' }}>Describe AWS shared responsibility model</li>
              <li style={{ marginBottom: '8px' }}>Define AWS pricing, account management, and support services</li>
            </ul>
          </div>

          {/* Domain Breakdown */}
          <div style={{ 
            background: '#fff', 
            borderRadius: '12px', 
            boxShadow: 'var(--shadow-sm)', 
            padding: '24px' 
          }}>
            <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '16px', color: 'var(--gray-800)' }}>
              📊 Domain Breakdown
            </h2>
            <div style={{ display: 'grid', gap: '12px' }}>
              {[
                { domain: 'Cloud Concepts', weight: '24%', color: 'var(--blue)' },
                { domain: 'Security and Compliance', weight: '30%', color: 'var(--green)' },
                { domain: 'Technology', weight: '34%', color: 'var(--orange)' },
                { domain: 'Billing and Pricing', weight: '12%', color: 'var(--purple)' },
              ].map((item) => (
                <div key={item.domain} style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  padding: '12px 16px',
                  background: 'var(--gray-50)',
                  borderRadius: '8px'
                }}>
                  <span style={{ fontWeight: 500, color: 'var(--gray-700)' }}>{item.domain}</span>
                  <span style={{ 
                    padding: '4px 12px', 
                    background: item.color, 
                    color: '#fff', 
                    borderRadius: '20px',
                    fontSize: '0.875rem',
                    fontWeight: 600
                  }}>{item.weight}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Key Services */}
          <div style={{ 
            background: '#fff', 
            borderRadius: '12px', 
            boxShadow: 'var(--shadow-sm)', 
            padding: '24px' 
          }}>
            <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '16px', color: 'var(--gray-800)' }}>
              🔧 Key AWS Services
            </h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '12px' }}>
              {[
                'EC2', 'S3', 'VPC', 'Lambda', 'CloudFront', 'RDS', 
                'DynamoDB', 'CloudWatch', 'IAM', 'Route 53', 'SQS', 'SNS'
              ].map((service) => (
                <div key={service} style={{ 
                  padding: '12px 16px', 
                  background: 'var(--gray-50)', 
                  borderRadius: '8px',
                  textAlign: 'center',
                  fontWeight: 500,
                  color: 'var(--gray-700)'
                }}>
                  {service}
                </div>
              ))}
            </div>
          </div>

          {/* Exam Preparation */}
          <div style={{ 
            background: '#fff', 
            borderRadius: '12px', 
            boxShadow: 'var(--shadow-sm)', 
            padding: '24px' 
          }}>
            <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '16px', color: 'var(--gray-800)' }}>
              🎯 Exam Preparation Tips
            </h2>
            <ul style={{ paddingLeft: '20px', color: 'var(--gray-600)' }}>
              <li style={{ marginBottom: '12px' }}>
                <strong style={{ color: 'var(--gray-800)' }}>Understand the shared responsibility model</strong> - Know what AWS manages vs what you manage
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong style={{ color: 'var(--gray-800)' }}>Learn the core services</strong> - Focus on EC2, S3, VPC, and IAM fundamentals
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong style={{ color: 'var(--gray-800)' }}>Practice with scenarios</strong> - The exam uses scenario-based questions
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong style={{ color: 'var(--gray-800)' }}>Review pricing models</strong> - Understand how AWS pricing works
              </li>
            </ul>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{ 
          display: 'flex', 
          gap: '16px', 
          marginTop: '32px',
          flexWrap: 'wrap'
        }}>
          <Link 
            to="/aws-exam-questions-ccp" 
            className="btn btn-primary"
            style={{ textDecoration: 'none' }}
          >
            Start Practice Exam
          </Link>
          <Link 
            to="/aws-clf-c02" 
            className="btn btn-outline-gray"
            style={{ textDecoration: 'none' }}
          >
            View Full Study Guide
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CLFExamPage;